import React, { FC, useEffect, useState } from 'react';

import { TransactionType } from '../../api-client';
import { Loader, Main, ModalContainer, Overlay, ScrollToTopButton } from '../../components';
import AlertNotifications from '../../components/alert-notifications/AlertNotifications/AlertNotifications';
import { Content, Footer, Header } from '../../components/layout';
import { createFeeSettings, createProfileManager } from '../../di';
import { useAppDispatch, useEffectOnMount, useErrorCallback, useLoggedInStatus } from '../../hooks';
import { set, setInvestmentFee } from '../../store/profile';
import { ChildrenProps } from '../../utils';

const LayoutCabinet: FC<ChildrenProps> = ({ children }) => {
  const dispatch = useAppDispatch();
  const isLoggedIn = useLoggedInStatus();
  const errorCallback = useErrorCallback();
  const [loading, setLoading] = useState(true);

  useEffectOnMount(() => {
    const mountCallback = async () => {
      setLoading(true);
      try {
        if (!isLoggedIn) {
          const initSession = async () => {
            await initProfile();
          };
          await initSession();
        }
      } catch (error: any) {
        await errorCallback(error);
      } finally {
        setLoading(false);
      }
    };
    (async () => {
      await mountCallback();
    })();
  });

  useEffect(() => {
    let cancelled = false;
    const id = setTimeout(async () => {
      if (cancelled) return;
      try {
        const provider = await createFeeSettings();
        const fee = await provider.getOne(TransactionType.INVESTMENT_FEE);
        dispatch(setInvestmentFee(fee));
      } catch (e: any) {
        await errorCallback(e);
      }
    }, 0);

    return () => {
      cancelled = true;
      clearTimeout(id);
    };
  }, []);

  const initProfile = async () => {
    const manager = await createProfileManager();
    const profile = await manager.get();
    dispatch(set(profile));
  };

  return (
    <Content>
      {loading ? (
        <Loader />
      ) : (
        <>
          <Header />
          <Overlay />
          <AlertNotifications />
          <Main cabinet>{children}</Main>
          <Footer />
          <ModalContainer />
          <ScrollToTopButton />
        </>
      )}
    </Content>
  );
};

export default LayoutCabinet;
